import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
} from "@mui/material";
import { Getrequest, Putrequest } from "../../../../../../context/AxiosRequest";
import { ContextData } from "../../../../../../context/Context";
import { toast } from "react-toastify";

export default function DisplayApprovedOfferLetterThirdParty({ user_tokens, from }) {
  const { UserTokens, accesstoken } = useContext(ContextData);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const printRef = React.useRef(null);

  const handlePrint = async () => {
    const printContent = printRef.current;
    if (!printContent) {
      toast.error("Unable to generate PDF. Please try again.");
      return;
    }

    try {
      // Show loading notification
      toast.info("Generating PDF, please wait...");

      // Dynamically import html2pdf only when needed
      const html2pdf = (await import("html2pdf.js")).default;

      // PDF options
      const options = {
        margin: [10, 10, 10, 10],
        filename: `Third_Party_Offer_Letter_${data?.clientName || 'Student'}_${new Date().getTime()}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { 
          scale: 2,
          useCORS: true,
          logging: false,
          letterRendering: true
        },
        jsPDF: { 
          unit: 'mm', 
          format: 'a4', 
          orientation: 'portrait'
        }
      };

      // Generate and download PDF
      await html2pdf()
        .set(options)
        .from(printContent)
        .save();
      
      toast.success("PDF downloaded successfully!");
    } catch (error) {
      console.error("PDF generation error:", error);
      toast.error("Failed to generate PDF. Please try again.");
    }
  };

 const [reload,setreload] = useState(false)
  const handleBorrowerSign = async() => {
    // Add borrower signature logic here
   
     
          const data = {

                    user_token: UserTokens,
                    from:"sponsor",
                    type:"borrower"
          }
          const response = await Putrequest("/auth/Submit_SignFinalOfferLetter",data)

          if(response.status){

                  toast.success(response.textStatus)
                  setreload(!reload)
          }else{

                toast.warn(response.textStatus)
                setreload(!reload)
                
          }



  };

  const handleGuarantorSign = async () => {
    // Add guarantor signature logic here
   


          const data = {

                    user_token: UserTokens,
                    from:"sponsor",
                    type:"guarantor"
          }
          const response = await Putrequest("/auth/Submit_SignFinalOfferLetter",data)

          if(response.status){

                  toast.success(response.textStatus)
                  setreload(!reload)
          }else{

                toast.warn(response.textStatus)
                setreload(!reload)
                
          }



  };





  useEffect(() => {
    const fetchApplicantData = async () => {
      try {
        setLoading(true);
        const response = await Getrequest(
          `/auth/get_disbursement_request/${user_tokens}`,
          accesstoken
        );

        if (response?.data) {
          setData(response.data);
        } else {
          setError("No applicant data found");
        }
      } catch (err) {
        setError("Failed to fetch applicant data");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (UserTokens) {
      fetchApplicantData();
    }
  }, [UserTokens, accesstoken, user_tokens,reload]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2, maxWidth: "900px", mx: "auto" }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!data) {
    return (
      <Box sx={{ p: 2, maxWidth: "900px", mx: "auto" }}>
        <Alert severity="info">No applicant data available</Alert>
      </Box>
    );
  }

  return (
    <Box>
      {/* Print Button */}
      { (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, '@media print': { display: 'none' } }}>
          <Button 
            variant="contained" 
            color="primary"
            onClick={handlePrint}
            sx={{ 
              fontWeight: 'bold', 
              fontSize: { xs: '0.7rem', sm: '0.875rem' }, 
              px: { xs: 2, sm: 3 },
              mt: 2,
              mr: 2
            }}
          >
            Download Letter
          </Button>
        </Box>
      )}
      
      {/* Printable Content */}
      <Box ref={printRef} className="!font-mono" sx={{ 
        p: { xs: 1, sm: 2, md: 4 }, 
        maxWidth: "900px", 
        mx: "auto", 
        backgroundColor: "#fff",
        fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
        overflowX: 'hidden'
      }}>
      
      {/* Header Section */}
      <Box sx={{ textAlign: "center", mb: { xs: 2, md: 4 } }}>
        <img 
          src="/newksslb.jpg" 
          alt="KSSLB Logo" 
          style={{ width: '80px', height: '80px', display: 'block', margin: '0 auto', marginBottom: '15px' }} 
        />
        
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ fontFamily: "monospace" }}>
          KADUNA STATE SCHOLARSHIP AND LOANS BOARD
        </Typography>
        <Typography variant="subtitle1" gutterBottom sx={{ fontFamily: "monospace" }}>
          IN COLLABORATION WITH
        </Typography>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ fontFamily: "monospace" }}>
          A.B.U MICROFINANCE BANK NIGERIA LIMITED
        </Typography>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ fontFamily: "monospace", mt: 2 }}>
          THIRD PARTY EDUCATION LOAN
        </Typography>
      </Box>

      {/* Salutation */}
      <Paper sx={{ p: { xs: 1.5, sm: 2, md: 3 }, mb: { xs: 2, md: 3 } }}>
        <Typography variant="body1" gutterBottom sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' } }}>
          Dear <strong>{data.clientName || "[Borrower's Name]"}</strong>,
        </Typography>
        <Typography variant="body1" paragraph sx={{ mt: 2, fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' } }}>
          We are pleased to inform you that your application for the <strong>Third party Education Loan</strong> has been approved under the following terms and conditions:
        </Typography>
      </Paper>

      {/* Facility Details */}
      <Paper sx={{ p: { xs: 1.5, sm: 2, md: 3 }, mb: { xs: 2, md: 3 }, overflowX: 'auto' }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
          Facility Details
        </Typography>
        
        <Table>
          <TableBody>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", width: "40%" }}>Facility Type:</TableCell>
              <TableCell>Student Tertiary Education Loan</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Loan Amount:</TableCell>
              <TableCell>{data.disbursementAmountText || "[…………….]"}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Tenure:</TableCell>
              <TableCell>5 years max.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Repayment:</TableCell>
              <TableCell>Monthly</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Interest Rate:</TableCell>
              <TableCell>8%</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Management Fee:</TableCell>
              <TableCell>4%</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Insurance Cover:</TableCell>
              <TableCell>0.9%</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Purpose:</TableCell>
              <TableCell>To finance tertiary education under the Kaduna State Scholarship and Loans Board scheme.</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>

      {/* Security/Collateral */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
          Security/Collateral
        </Typography>
        <Typography variant="body1" paragraph>
          This facility shall be secured by:
        </Typography>
        <Box component="ul" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            A <strong>guarantor/co-debtor undertaking</strong>, jointly and severally binding the Borrower and guarantor to full repayment of the facility.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            The Bank's right of <strong>set-off/Global Standing Instruction (GSI)</strong> on any funds standing to the credit of accounts maintained by the Borrower and/or guarantor with the Bank or any other financial institution in Nigeria.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Any other security that may be required by the Bank or the Kaduna State Scholarship and Loans Board from time to time.
          </Typography>
        </Box>
      </Paper>

      {/* General Terms and Conditions */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
          General Terms and Conditions
        </Typography>
        <Box component="ol" sx={{ pl: 3 }}>
          <Typography component="li" variant="body1" paragraph>
            The Borrower shall maintain the designated account with the Bank for the duration of this facility.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            The Borrower irrevocably authorizes the Bank to debit his/her account for repayment of principal, interest, and applicable charges until full liquidation of the facility.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            In the event of default, the Kaduna State Scholarship and Loans Board scheme reserves the right to notify the Borrower's employer.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            The Borrower authorizes the Bank to access relevant information from authorized sources for loan processing and to disclose financial/personal data to regulatory bodies as required by law.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Kaduna State Scholarship and Loans Board in conjunction with A.B.U Microfinance Bank, may review the facility terms (pricing, repayment, overdue charges) in line with market conditions or terminate the facility in case of adverse information or breach.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Kaduna State Scholarship and Loans Board in conjunction with the Bank may disclose the Borrower's information to referees, guarantors, spouse, relatives, debt recovery agents, lawyers, or any other third party for loan recovery purposes.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            The Borrower shall notify Kaduna State Scholarship and Loans Board scheme within 24 hours of any change in employment status.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            The Borrower waives the right to contest amendments to this facility, provided such amendments are communicated by e-mail, SMS, or any official channel.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            This facility is subject to the laws of the Federal Republic of Nigeria and the jurisdiction of Nigerian courts.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            The Bank shall not be liable for losses or damages arising from this facility. If the facility is not fully repaid within the agreed tenure, this Agreement shall remain enforceable until full repayment.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Fraudulent activities (e.g., forged documents, salary diversion) shall result in restrictions on the Borrower's account and may be reported to law enforcement agencies.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            All costs and out-of-pocket expenses (e.g., legal fees, stamp duties) incurred in connection with this facility shall be borne by the Borrower.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            Kaduna State Scholarship and Loans Board in conjunction with Bank reserves the right to verify all information provided, including employer and guarantor details.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            The Borrower confirms that guarantor information is correct and accepts liability for the commitments of the guarantor/co-debtor.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            In the event of default, repayment shall be enforced against both the Borrower and the guarantor/co-debtor.
          </Typography>
        </Box>
      </Paper>

      {/* Acceptance Section */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
          Acceptance
        </Typography>
        <Typography variant="body1" paragraph>
          I, the undersigned, confirm that I have read, understood, and accepted the terms and conditions of this facility as stated above.
        </Typography>

        {/* Signature Lines */}
        <Box sx={{ mt: 4 }}>
          <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, justifyContent: "space-between", mb: { xs: 2, md: 4 }, gap: { xs: 2, sm: 0 } }}>
            <Box sx={{ width: { xs: '100%', sm: '45%' } }}>
              <Typography variant="body2" gutterBottom sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>
                <strong>Borrower's Name:</strong> <span>{data.clientName || "[…………….]"}</span>
              </Typography>
            </Box>
            <Box sx={{ width: { xs: '100%', sm: '45%' } }}>
              <Typography variant="body2" gutterBottom sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>
                <strong>Signature/Date:</strong> {data.file_sponsor_sign === null ? "waiting for Borrower..." : <span>{`${data.file_sponsor_sign}/${data.updatedAtDate_sponsor}: Time: ${data.updatedAtTime_sponsor}` || "[…………….]"}</span>}
              </Typography>
              {from === "thirdparty_applicant" && data.file_sponsor_sign === null && (
                <Button 
                  variant="contained" 
                  color="success"
                  size="small"
                  onClick={handleBorrowerSign}
                  sx={{ fontWeight: 'bold', mt: 1, fontSize: { xs: '0.65rem', sm: '0.75rem' }, '@media print': { display: 'none' } }}
                >
                  Sign as Borrower
                </Button>
              )}
            </Box>
            
          </Box>

          <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, justifyContent: "space-between", mb: { xs: 2, md: 4 }, gap: { xs: 2, sm: 0 } }}>
            <Box sx={{ width: { xs: '100%', sm: '45%' } }}>
              <Typography variant="body2" gutterBottom sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>
                <strong>Guarantor/Co-Debtor's Name:</strong> <span>{data.guarantor || "[…………….]"}</span>
              </Typography>
            </Box>
            <Box sx={{ width: { xs: '100%', sm: '45%' } }}>
              <Typography variant="body2" gutterBottom sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>
                <strong>Signature/Date:</strong> {data.file_guarantor_sign_t === null ? "waiting for Guarantor..." : <span>{`${data.file_guarantor_sign_t}/${data.updatedAtDate_guarantor_t}: Time: ${data.updatedAtTime_guarantor_t}` || "[…………….]"}</span>}
 

              </Typography>
              {from === "thirdparty_applicant" && data.file_guarantor_sign_t === null && (
                <Button 
                  variant="contained" 
                  color="info"
                  size="small"
                  onClick={handleGuarantorSign}
                  sx={{ fontWeight: 'bold', mt: 1, fontSize: { xs: '0.65rem', sm: '0.75rem' }, '@media print': { display: 'none' } }}
                >
                  Sign as Guarantor
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Paper>

      {/* Official Signatures */}
      <Paper sx={{ p: { xs: 1.5, sm: 2, md: 3 } }}>
        <Typography variant="body1" fontWeight="bold" gutterBottom sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
          For: KADUNA STATE SCHOLARSHIP & LOANS BOARD.
        </Typography>

         <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, justifyContent: "space-between", mt: 4, gap: { xs: 3, sm: 0 } }}>
                 <Box sx={{ textAlign: "center", width: { xs: '100%', sm: '45%' } }}>
                  <Box sx={{ textAlign: 'center',marginTop:"2em" }}>
                               <Box 
                                 sx={{ 
                                   width: { xs: '150px', sm: '200px' },
                                   height: { xs: '60px', sm: '80px' },
                                   border: '1px dashed #ccc',
                                   display: 'flex',
                                   alignItems: 'center',
                                   justifyContent: 'center',
                                   margin: '0 auto',
                                   mb: 1
                                 }}
                               >
                                 <Typography variant="caption" sx={{marginBottom:"3em"}} color="text.secondary">
                                   <img src="/assets/es-sign.jpeg" alt="Signature" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                                 </Typography>
                               </Box>
                               <Typography variant="body1" fontWeight="bold" sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
                                 Prof. Yahya Saleh Ibrahim
                               </Typography>
                               <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>
                                 Executive Secretary
                               </Typography>
                             </Box>
                 </Box>
       
                 <Box sx={{ textAlign: "center", width: { xs: '100%', sm: '45%' } }}>
              
                    <Box sx={{ textAlign: 'center',marginTop:"2em" }}>
                                 <Box 
                                   sx={{ 
                                     width: { xs: '150px', sm: '200px' },
                                     height: { xs: '60px', sm: '80px' },
                                     border: '1px dashed #ccc',
                                     display: 'flex',
                                     alignItems: 'center',
                                     justifyContent: 'center',
                                     margin: '0 auto',
                                     mb: 1
                                   }}
                                 >
                                  <Typography variant="caption" sx={{marginBottom:"3em"}} color="text.secondary">
                                     <img src="/assets/iyalsign.png" alt="Signature" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                                   </Typography>
                                 </Box>
                                 <Typography variant="body1" fontWeight="bold" sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
                                   Liman Iyal Zubair
                                 </Typography>
                                 <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>
                                   Director of Loans Department
                                 </Typography>
                               </Box>
                 </Box>
               </Box>
      </Paper>
      </Box>
    </Box>
  );
}
